export const FEEDBACK_MESSAGE_MAX = 2000;

export const FEEDBACK_RATINGS = [
  { value: 1, label: 'Very dissatisfied', emoji: '😠' },
  { value: 2, label: 'Dissatisfied', emoji: '🙁' },
  { value: 3, label: 'Neutral', emoji: '😐' },
  { value: 4, label: 'Satisfied', emoji: '🙂' },
  { value: 5, label: 'Very satisfied', emoji: '😄' },
] as const;

export type FeedbackRatingValue = (typeof FEEDBACK_RATINGS)[number]['value'];

export type FeedbackSource = {
  sourcePage: string;
  productName: 'HireVeda' | 'HV' | 'ExecEdge';
};

function cleanPath(pathname: string): string {
  const path = String(pathname || '/').split('?')[0].split('#')[0] || '/';
  return path.slice(0, 300);
}

export function resolveFeedbackSource(pathname: string): FeedbackSource {
  const sourcePage = cleanPath(pathname);

  if (
    sourcePage === '/NewExecedge' ||
    sourcePage.startsWith('/NewExecedge/') ||
    sourcePage === '/eedge' ||
    sourcePage.startsWith('/eedge/') ||
    sourcePage === '/execedge-funnel' ||
    sourcePage.startsWith('/execedge-funnel/') ||
    sourcePage === '/execedge' ||
    sourcePage.startsWith('/execedge/')
  ) {
    return { sourcePage, productName: 'ExecEdge' };
  }
  if (
    sourcePage === '/hv' ||
    sourcePage.startsWith('/hv/') ||
    sourcePage === '/Tracker' ||
    sourcePage.startsWith('/Tracker/')
  ) {
    return { sourcePage, productName: 'HV' };
  }
  return { sourcePage, productName: 'HireVeda' };
}
